var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: _vm.buttonClassName,
      attrs: {
        click: _vm.handleClick(),
        type: _vm.isSubmit ? "submit" : "button"
      }
    },
    [_vm._t("default"), _vm._v(" "), _vm._m(0)],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "load-button-loader loading-dots flex-row align-items-center justify-content-center"
      },
      [
        _c("div", { staticClass: "dot" }),
        _vm._v(" "),
        _c("div", { staticClass: "dot" }),
        _vm._v(" "),
        _c("div", { staticClass: "dot" })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13b58e3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13b58e3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/load-button.vue
// module id = null
// module chunks = 